import { render, staticRenderFns } from "./coderInpatientResponses.vue?vue&type=template&id=1431a8aa&scoped=true&"
import script from "./coderInpatientResponses.vue?vue&type=script&lang=js&"
export * from "./coderInpatientResponses.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientResponses.vue?vue&type=style&index=0&id=1431a8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431a8aa",
  null
  
)

export default component.exports